<template>
  <FormContainer :withoutDivider="true">
    <template #content>
      <div class="form__bloc">
        <WrapperCheckbox
          id="field_92"
          v-model="attestationTuteurCriteresEligibiliteModel"
          label="L’employeur atteste sur l’honneur que le(s) tuteur(s) répond(ent) à l’ensemble des critères d’éligibilité à cette fonction."
          :required="meta.tutorat?.attestationTuteurCriteresEligibilite?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.attestationTuteurCriteresEligibilite?.$messageErreurDirty!"
          :readonly
          class="col-36"
          style="margin: -5px 0"
        />
        <WrapperCheckbox
          id="field_87"
          v-model="attestationTuteurTroisStagiairesModel"
          label="L’employeur atteste sur l’honneur que chaque tuteur encadre au maximum 3 stagiaires."
          :required="meta.tutorat?.attestationTuteurTroisStagiaires?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.attestationTuteurTroisStagiaires?.$messageErreurDirty!"
          :readonly
          class="col-36"
          style="margin: -5px 0"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { useDemandePROAStore } from '../../../../useDemandePROAStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { FormContainer } from '@/features/interface/demande/shared'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const attestationTuteurCriteresEligibiliteModel = setupFieldWithKey<boolean>(
    'tutorat.attestationTuteurCriteresEligibilite',
  )
  const attestationTuteurTroisStagiairesModel = setupFieldWithKey<boolean>('tutorat.attestationTuteurTroisStagiaires')
</script>
